// NOTE: https://github.com/wix-private/users/tree/master/login-statics
const SIGN_IN_URL = window.__SIGN_IN_URL__;

interface IRedirectToLoginArgs {
  returnUrl?: string;
}

let _isRedirectToLoginRequested = false;

function isRedirectToLoginRequested() {
  return _isRedirectToLoginRequested;
}

function redirectToLogin({ returnUrl }: IRedirectToLoginArgs = {}): void {
  const encodedReturnUrl = encodeURIComponent(
    returnUrl || window.location.href,
  );
  const locale = window.__LOCALE__;

  window.location.replace(
    `${SIGN_IN_URL}?redirectTo=${encodedReturnUrl}&overrideLocale=${locale}`,
  );

  _isRedirectToLoginRequested = true;
}

export { isRedirectToLoginRequested };

export default redirectToLogin;
